var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/engine-user-agent.js
// module id = 525
// module chunks = 1